import { render } from "./WCAvailableCouponsModal.vue?vue&type=template&id=15d8e2a8&scoped=true"
import script from "./WCAvailableCouponsModal.vue?vue&type=script&lang=js"
export * from "./WCAvailableCouponsModal.vue?vue&type=script&lang=js"

import "./WCAvailableCouponsModal.vue?vue&type=style&index=0&id=15d8e2a8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15d8e2a8"]])

export default __exports__